<template>
	<div class="brick view_brick">
		<div class="view_inner">
			<table class="view_tbl">
				<colgroup>
					<col width="80px" />
					<col />
				</colgroup>
				<tr>
					<th>Title</th>
					<td>
						<input type="hidden" v-model="notice.notice_no" />
						<input type="text" class="tbl_int" v-model="notice.subject" :disabled="mode === 'detail'" />
					</td>
				</tr>
				<tr>
					<th>Dept</th>
					<td>
						<label>
							<select v-model="notice.code" class="tbl_select sm_int" :disabled="mode === 'detail'">
								<option v-for="dept in codeList" v-bind:value="dept.code" v-bind:key="dept.cpde">
									{{ dept.name }}
								</option>
							</select>
						</label>
					</td>
				</tr>
				<tr>
					<th style="vertical-align: top; padding-top: 5px;">Contents</th>
					<td>
						<editor :content="notice.contents" @input="onEditorUpdate" :readonly="mode === 'detail'" />
					</td>
				</tr>
			</table>

			<div class="attact_file_box">
				<p class="int_file_p" v-if="mode !== 'detail'">
					<input type="file" multiple @change="previewFiles" ref="files" />
				</p>
				<ul>
					<li v-for="(file, index) in notice.noticeFiles" :key="index">
						<em v-if="file.del === 'N'">
							<span v-on:click="fileDownload(index)"> {{ file.exportName }} </span>
							<a href="javascript:void(0);" @click="deleteFile(index)" v-if="mode === 'update'">delete</a>
						</em>
					</li>
					<li v-for="(file, index) in notice.fileNames" :key="index">
						<em v-if="file.del === 'N'">
							{{ file.name }}
						</em>
					</li>
				</ul>
			</div>
			<div class="view_bottom_bt">
				<a href="javascript:history.back();" class="gray_bt mgr_5">Back</a>
				<a href="javascript:void(0);" v-if="isDetailModeAndCanModify" class="search_bt mgr_5" @click="modifyView">Modify</a>
				<a href="javascript:void(0);" v-else-if="notice_modify" class="search_bt mgr_5" @click="submitNotice">Save & Return To Previous Page</a>
				<a href="javascript:void(0);" v-if="isNotAddModeAndCanModify" class="gray_bt" @click="deleteNotice">Delete</a>
			</div>
		</div>
	</div>
</template>

<script>
import { apiDeleteNotice, apiSelectNotice, apiInsertNotice } from '@/api/basicinfo/notice';
import { apiSelectCodeList } from '@/api/basicinfo/code';
import Editor from '@/components/common/Editor';
import { apiFileDownload } from '@/api/util';

export default {
	name: 'NoticeForm',
	props: ['mode'],
	computed: {
		session_user() {
			return this.$session.get('user');
		},
		notice_modify() {
			return this.session_user.notice_management || this.session_user.admin_yn === 'Y';
		},
		isDetailModeAndCanModify() {
			return this.mode === 'detail' && this.notice_modify;
		},
		isNotAddModeAndCanModify() {
			return this.mode !== 'add' && this.notice_modify;
		},
	},
	components: { Editor },
	data: function() {
		return {
			notice: {
				contents: '',
				fileNames: [],
			},
			codeList: {},
		};
	},
	methods: {
		async selectNotice() {
			const noticeNo = this.$route.query.noticeNo;
			const { data } = await apiSelectNotice(noticeNo);
			this.notice = data.notice;
			this.notice.deleteFiles = [];
		},

		async selectCodes() {
			let { data } = await apiSelectCodeList({ code_type: 'DP', active_yn: 'Y' });
			this.codeList = data.codeList;
		},

		async submitNotice() {
			if (!this.notice_modify) {
				this.$toast.error('You do not have permission to modify');
				return false;
			}

			if (!this.notice.subject) {
				this.$toast.error('Please enter a Subject');
				return false;
			}

			if (!this.notice.code) {
				this.$toast.error('Please enter a Code');
				return false;
			}

			let { data } = await apiInsertNotice(this.notice);
			if (data.result_code) {
				await this.$router.push({ path: '/' });
			} else {
				this.$toast.error('error');
			}
		},

		onEditorUpdate(value) {
			this.notice.contents = value;
		},

		previewFiles(event) {
			const fileList = event.target.files;
			this.notice.files = this.$refs.files.files;
			this.notice.fileNames = [];
			for (const file of fileList) {
				this.notice.fileNames.push({ name: file.name, del: 'N' });
			}
		},

		fileDownload(index) {
			let file = this.notice.noticeFiles[index];
			apiFileDownload('/api/basic_info/notices/file/' + file.file_no, file.exportName);
		},

		deleteFile(index) {
			if (!this.notice_modify) {
				this.$toast.error('You do not have permission to modify');
				return false;
			}

			const file = this.notice.noticeFiles[index];
			file.del = 'Y';
			this.notice.deleteFiles.push(file.file_no);
		},

		modifyView() {
			if (!this.notice_modify) {
				this.$toast.error('You do not have permission to modify');
				return false;
			}

			this.$router.push({ name: 'noticeForm', params: { mode: 'update' }, query: { noticeNo: this.$route.query.noticeNo } });
		},

		async deleteNotice() {
			if (!this.notice_modify) {
				this.$toast.error('You do not have permission to modify');
				return false;
			}

			const { data } = await apiDeleteNotice(this.notice.noticeNo);
			if (data.result_code === 'success') {
				this.$toast.success();
				await this.$router.push({ path: '/' });
			} else {
				this.$toast.error('error');
			}
		},
	},
	created() {
		this.selectCodes();
		if (this.mode === 'detail') {
			this.selectNotice();
		} else if (this.mode === 'update') {
			this.selectNotice();
		}
	},
};
</script>

<style scoped></style>
